"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const index_1 = require("../index");
function CustomNotification({ notification, important, selected, onSelect, hasSelected, }) {
    const bridge = (0, bridge_1.useBridge)();
    const { identifier, message } = notification;
    const { url, button, description } = message;
    const action = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: url });
    };
    return ((0, jsx_runtime_1.jsx)(index_1.Notification, { selected: selected, onSelect: onSelect, important: important, isGroup: true, notification: notification, description: description, hasSelected: hasSelected, buttons: [
            {
                action,
                identifier,
                title: button,
                type: index_1.ButtonType.Secondary,
            },
        ], "data-e2e": 'CustomNotification_Notification' }));
}
exports.default = (0, bridge_1.withBridgeProvider)(CustomNotification);
